import React, { useEffect } from 'react';
import IFrameService from '../../utils/iframe';
import { getUserFromLocalStorage } from '../../utils/oidc';

export interface IFrameProps {
  option: string;
  elementId: string;
  source: unknown;
  needsReload: boolean;
}

const IFrameComponent: React.FC<IFrameProps> = (props: IFrameProps) => {
  const { option, elementId, source, needsReload } = props;

  useEffect(() => { // Adiciona o iframe ao DOM quando o componente é montado
    const iframeHtml = `<iframe id='${elementId}' src='${source}'></iframe>`;
    var iframeContainer = document.getElementById('iframe-container');
    var iframe = document.getElementById(elementId) as HTMLIFrameElement;
    if (iframeContainer) {
      iframeContainer.style.display = 'block';
      if (iframe) {
        iframe.style.display = 'block';
      } else {
        const iframeElement = document.createElement('div');
        iframeElement.innerHTML = iframeHtml;
        iframeContainer.appendChild(iframeElement.firstChild as Node);
      }
    }

    return () => {
      // esconde o iframe do DOM quando o componente é desmontado
      const iframeContainer = document.getElementById('iframe-container');
      if (iframeContainer) {
        iframeContainer.style.display = 'none';
        const iframe = document.getElementById(elementId);
        if (iframe) {
          iframe.style.display = 'none';
        }
      }
    };
  }, [source, elementId]);

  useEffect(() => {
    const iframe = document.getElementById(elementId) as HTMLIFrameElement;
    const user = getUserFromLocalStorage();
    if (iframe) {
      IFrameService.navigate(iframe, option, user);
    }
  }, [option]);

  useEffect(() => {
    if (needsReload) {
      IFrameService.reloadIframe();
    }
  }, [needsReload, elementId]);

  return (
    <>
    </>
  );
};

export default IFrameComponent;
